import React from 'react';
import cx from 'classnames';

export default class Overlay extends React.PureComponent {
  render() {
    return (
      <div
        className={cx('overlay', this.props.className, { 'is-visible': this.props.visible })}
        onClick={this.props.onClick}
      >
        {this.props.children}
      </div>
    );
  }
}

Overlay.propTypes = {
  className: React.PropTypes.string,
  children: React.PropTypes.element,
  onClick: React.PropTypes.func,
  visible: React.PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/component/Overlay.jsx